import { useParams, Link } from 'react-router-dom'
import React, { useEffect, useRef } from 'react'
import './ClientApp.scss'
import { useState } from 'react'
import { use } from '../Helpers'
import { call } from '../Methods'
import Variables from '../global'
import generatePDF from 'react-to-pdf'

function OrderView () {
  const { id } = useParams()
  const [loading, setLoading] = useState(true)
  const [order, setOrder] = useState(null)
  const printRef = useRef()

  const getOrder = async () => {
    setLoading(true)
    const order = await call.forLoggedUser.order.getOrder(id)
    if (order.success) {
      console.log(order.data)
      setOrder(order.data)
    }
    setLoading(false)
  }

  useEffect(() => {
    getOrder()
  }, [])

  if (loading) return <div className='loading'>Loading...</div>
  return (
    <React.Fragment>
      {order && (
        <div className='page client-orderview-page'>
          <div className='client-orderview container'>
            <div>
              <Link className='back-button' to='/dashboard#orders'>
                <img src='/Icons/arrow-left.png' />
                Back to Orders
              </Link>
            </div>
            <div className='order-details' ref={printRef}>
              <div className='buttons'>
                <Link
                  className='print-button'
                  onClick={e => {
                    e.preventDefault()
                    window.print()
                  }}
                  href=''
                >
                  <img src='/Icons/printer.png' alt='Print' title='Print' />
                </Link>

                <Link
                  className='download-button'
                  onClick={e => {
                    e.preventDefault()
                    generatePDF(printRef, {
                      filename: `Order ${order.orderNumber}.pdf`
                    })
                  }}
                  href=''
                >
                  <img
                    src='/Icons/download.png'
                    alt='Download'
                    title='Download'
                  />
                </Link>
              </div>

              <div className='order-info-headline'>
                <h5>
                  <b>[{order.orderNumber}]</b> Order Details
                </h5>
              </div>

              <div className='order-info-header'>
                <div className='order-date'>
                  Date: <b>{use.convertUTCToLocalISOString(order.createDate)}</b>
                </div>
                <div className='order-number'>
                  Payment Status: <b>{order.paymentStatus}</b>
                </div>
                <div className='order-status'>
                  Order Status: <b>{order.statusName}</b>
                </div>
              </div>
              <h4 className='items-header'>Items</h4>
              <div className='order-items'>
                <table className='table table-bordered'>
                  <thead>
                    <tr>
                      <th>Image</th>
                      <th>Product</th>
                      <th>Quantity</th>
                      <th>Price</th>
                      <th>Line Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {order.orderItems.map((item, index) => (
                      <tr key={index}>
                        <td>
                          <img
                            className='item-image'
                            src={`${Variables.base_url}/api/images/thumbnail-sm/${item.imageUrl}`}
                          />
                        </td>
                        <td>
                          {' '}
                          {item.itemName} (
                          <b>
                            <em>{item.itemNumber}</em>
                          </b>
                          )
                        </td>
                        <td>{item.quantity}</td>
                        <td>${item.singleItemPrice}</td>
                        <td>${item.totalPrice}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className='order-info-footer'>
                <div className='order-discount info-row'>
                  <span className='key'>Discount:</span>{' '}
                  <span className='value'>${order.discountedPrice}</span>
                </div>
                <div className='order-subtotal info-row'>
                  <span className='key'>Sub Total:</span>{' '}
                  <span className='value'>${order.subTotal}</span>
                </div>
                <div className='order-tax info-row'>
                  <span className='key'>Tax:</span>{' '}
                  <span className='value'>${order.hst}</span>
                </div>
                <div className='order-total info-row'>
                  <span className='key'>Total:</span>{' '}
                  <span className='value'>${order.totalAmount}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  )
}

export default OrderView
